module.exports = __webpack_public_path__ + "img/sec3_slide3.435a89a0.jpg";